export function toggleStudentPresence(eventId, studentId) {
  return {
    type: "TOGGLE_STUDENT_PRESENCE",
    eventId,
    studentId
  };
}

export function initStudentsForEvent(eventId) {
  return {
    type: "INIT_STUDENTS_FOR_EVENT",
    eventId
  };
}



// WEBPACK FOOTER //
// ./actions/students.js